export default function (n) {
  const integer = Math.floor(n)
  return integer
}
